function Header() {

  return (
    <header className="App-header">
      <img src="/logo-logo-cc.svg" className="App-logo" alt="logo" />
    </header>
  )
}

export default Header